module.exports = __webpack_public_path__ + "img/icon-outrights.1d52a164.svg";